<birdz-card [isLoading]="isLoading" [isEmpty]="!hasPerimeter || !isAvailableForSelectedTecho">
  <div card-title>
    {{ 'REMOTE_READ_POS' | transloco }}
    <button
      class="help-button bdz-mat-icon-button-info-variant"
      matIconButton
      [matTooltip]="'HELP' | transloco"
      (click)="help()"
    >
      <mat-icon>help</mat-icon>
    </button>
  </div>
  <div card-corner class="corner-export-icon">
    @if (hasPerimeter && isAvailableForSelectedTecho && !isLoading) {
      <button
        matIconButton
        class="bdz-mat-icon-button-primary"
        (click)="export()"
        [matTooltip]="'EXPORT_DATA' | transloco"
      >
        <mat-icon>download_2</mat-icon>
      </button>
    }
  </div>
  <div card-subtitle>
    @if (hasPerimeter && isAvailableForSelectedTecho && remoteReadingStatsLastModified) {
      {{ 'DATE_AT' | transloco }} {{ remoteReadingStatsLastModified | formatDatetimeTimezone }}
    }
  </div>
  <div card-empty>
    {{ (!isAvailableForSelectedTecho ? 'NOT_AVAILABLE_FOR_SELECTED_TECHNO' : 'PLEASE_SELECT_A_CONTRACT') | transloco }}
  </div>
  <div card-body class="body">
    @if (remoteReadingStats?.devices_total === null) {
      <div class="no-data">{{ 'NO_DATA_AVAILABLE' | transloco }}</div>
    } @else {
      <!-- total -->
      <div class="total">
        {{ 'REMOTE_READ_DEVICE_COUNT' | transloco }}{{ 'COLON' | transloco }} {{ total | formatNumber }}
        <div class="toggle">
          <mat-slide-toggle (change)="toggleView()" [(ngModel)]="isDetailedView">
            {{ 'DETAILED_VIEW' | transloco }}
          </mat-slide-toggle>
        </div>
      </div>
      <!-- chart -->
      @if (chartOptions) {
        <div class="chart-layout">
          <highcharts-chart
            (chartInstance)="setChartInstance($event)"
            class="chart"
            [options]="chartOptions"
          ></highcharts-chart>
          <div class="legend">
            <app-legend-item
              id="connected_functional"
              [forceDisplay]="true"
              [color]="categoryColors['OK']"
              [children]="getLegendItemChildren('OK')"
              [chart]="chart"
              [update]="updateFlag"
              title="{{ 'CONNECTED_FUNCTIONAL' | transloco }}"
              [subtitle]="subtitle"
            />
            @for (legendItem of detailedLegendItems['OK']; track legendItem) {
              <app-legend-item
                [id]="legendItem.id"
                [chart]="chart"
                [update]="updateFlag"
                [level]="1"
                [title]="legendItem.title"
                [subtitle]="subtitle"
                [compact]="true"
              />
            }
            <app-legend-item
              id="connected_non_functional_hs"
              [forceDisplay]="true"
              [color]="categoryColors['HS']"
              [children]="getLegendItemChildren('HS')"
              [chart]="chart"
              [update]="updateFlag"
              title="{{ 'CONNECTED_NONFUNCTIONAL_HS' | transloco }}"
              [subtitle]="subtitle"
            />
            @for (legendItem of detailedLegendItems['HS']; track legendItem) {
              <app-legend-item
                [id]="legendItem.id"
                [chart]="chart"
                [update]="updateFlag"
                [level]="1"
                [title]="legendItem.title"
                [subtitle]="subtitle"
                [compact]="true"
              />
            }
            <app-legend-item
              id="connected_non_functional_nc"
              [forceDisplay]="true"
              [color]="categoryColors['NC']"
              [children]="getLegendItemChildren('NC')"
              [chart]="chart"
              [update]="updateFlag"
              title="{{ 'CONNECTED_NONFUNCTIONAL_NC' | transloco }}"
              [subtitle]="subtitle"
            />
            @for (legendItem of detailedLegendItems['NC']; track legendItem) {
              <app-legend-item
                [id]="legendItem.id"
                [chart]="chart"
                [update]="updateFlag"
                [level]="1"
                [title]="legendItem.title"
                [subtitle]="subtitle"
                [compact]="true"
              />
            }
            <app-legend-item
              id="not_connected"
              [forceDisplay]="true"
              [color]="categoryColors['NON_RACCORDE']"
              [children]="getLegendItemChildren('NON_RACCORDE')"
              [chart]="chart"
              [update]="updateFlag"
              title="{{ 'NOT_CONNECTED' | transloco }}"
              [subtitle]="subtitle"
            />
            @for (legendItem of detailedLegendItems['NON_RACCORDE']; track legendItem) {
              <app-legend-item
                [id]="legendItem.id"
                [chart]="chart"
                [update]="updateFlag"
                [level]="1"
                [title]="legendItem.title"
                [subtitle]="subtitle"
                [compact]="true"
              />
            }
          </div>
        </div>
      }
      <!-- figures -->
      @if (remoteReadingStats) {
        <div class="figures">
          <div class="figure figure--ok">
            {{
              (total === 0 ? 0 : ((remoteReadingStats.devices_connected_functional ?? 0) / total) * 100)
                | formatNumber: '0.0-1'
            }}% {{ 'OF_DEVICES_CONNECTED_FUNCTIONAL' | transloco }}
          </div>
          <div class="figure figure--ko">
            {{
              (total === 0 ? 0 : ((remoteReadingStats.devices_not_connected ?? 0) / total) * 100)
                | formatNumber: '0.0-1'
            }}% {{ 'OF_DEVICES_NOT_CONNECTED' | transloco }}
          </div>
        </div>
      }
    }
  </div>
</birdz-card>
